module.exports = __webpack_public_path__ + "static/media/sso_error.380cba11.png";